module.exports = __webpack_public_path__ + "8b019d0a7ab095f94081b7c046326cab.pdf";